/* eslint-disable react/function-component-definition */
import React from 'react';
import useSWR from 'swr';

import { getDocsEntries } from 'react-scale/lib/content/docs';
import handleError from 'react-scale/lib/handle-error';

import DocsContainer from 'react-scale/containers/docs';
import Spinner from 'react-scale/components/ui/spinner';
import { fetchDocsIndexData } from '.';
import { getDocsIndexData, getDocContent } from '../api/docs';

async function fetchDocsPageContent(slug) {
  const res = await fetch(`/api/docs?slug=${slug}`);
  if (!res.ok) {
    throw res.text();
  }
  return res.json();
}

export async function getStaticPaths() {
  let pages = [];

  try {
    pages = await getDocsEntries();
  } catch (error) {
    handleError(error);
  }

  const paths = pages.map(page => ({
    params: { slug: page.slug }
  }));

  return {
    paths,
    fallback: true
  };
}

export async function getStaticProps({ params }) {
  let props;
  try {
    const [{ topLevelNavigation, subLevelNavigation }, content] = await Promise.all([
      getDocsIndexData(),
      getDocContent(params.slug)
    ]);
    props = { content, topLevelNavigation, subLevelNavigation, slug: params.slug };
  } catch (error) {
    handleError(error);
  }

  return { props, revalidate: 1 };
}

const Docs = props => {
  const { data } = useSWR('docs-index', fetchDocsIndexData, {
    fallbackData: {
      topLevelNavigation: props.topLevelNavigation,
      subLevelNavigation: props.subLevelNavigation
    },
    refreshInterval: 5000
  });
  const { data: content } = useSWR(
    ['docs-page', props.slug],
    () => fetchDocsPageContent(props.slug),
    { fallbackData: props.content, refreshInterval: 5000 }
  );

  if (!content) {
    return (
      <div className="flex items-center justify-center w-screen h-screen">
        <Spinner size="sm" />
      </div>
    );
  }

  return (
    <DocsContainer
      topLevelNavigation={data.topLevelNavigation}
      subLevelNavigation={data.subLevelNavigation}
      slug={props.slug}
      title={content.title}
      content={content.body_html}
      updated={content.updatedAt}
    />
  );
}

Docs.defaultProps = {
  slug: null
};

export default Docs;
